<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="navbar-brand navbar-brand-choose-plan">
		<img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
	</section>
</header>
<header class="mobile-header">
	<img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
</header>
<section class="container plan-subscription-container">
    <h1 class="title">Your Zenplans subscription has expired</h1>
    <div class="content">
        Please purchase a subscription to continue organising your <br> life’s important information with Zenplans.
    </div>
    <input type="submit" class="btn btn-primary primary-default-btn puchase-btn" value="Purchase Subscription" (click)="openPortal()"/>
</section>